import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectFilePickerInputItemDirective } from './project-file-picker-input-item.directive';

@NgModule({
  declarations: [
    ProjectFilePickerInputItemDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ProjectFilePickerInputItemDirective
  ]
})
export class ProjectFilePickerInputItemModule { }
